import React from 'react';
import AuthImage from '../media/AuthImage';
import { renderParts } from './templateUtils';

/**
 * Vista previa de la plantilla como burbuja de WhatsApp.
 * headerImageUrl: imagen fija cargada en el portal (encabezado de imagen).
 */
export default function TemplatePreview({ components, vars, headerImageUrl }) {
  const p = renderParts(components, vars);
  return (
    <div style={s.wrap}>
      <div style={s.bubble}>
        {p.headerFormat === 'IMAGE' && headerImageUrl
          ? <div style={s.image}><AuthImage url={headerImageUrl} alt="Imagen de la plantilla" maxHeight={200} style={{ width: '100%', objectFit: 'cover' }} /></div>
          : p.header && <div style={s.header}>{p.header}</div>}
        <div style={s.body}>{p.body || <span style={{ opacity: 0.5 }}>El cuerpo del mensaje aparecerá aquí</span>}</div>
        {p.footer && <div style={s.footer}>{p.footer}</div>}
      </div>
      {p.buttons.map((b, i) => <div key={i} style={s.button}>{b}</div>)}
    </div>
  );
}

const s = {
  wrap: { background: '#0b141a', borderRadius: 12, padding: 14, display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-start' },
  bubble: { background: '#005c4b', color: '#e9edef', borderRadius: '8px 8px 8px 2px', padding: '8px 10px', maxWidth: 320, fontSize: 13.5, lineHeight: 1.45, whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
  header: { fontWeight: 700, marginBottom: 4 },
  image: { margin: '-4px -6px 6px', borderRadius: 6, overflow: 'hidden' },
  body: {},
  footer: { fontSize: 11.5, color: '#8696a0', marginTop: 6 },
  button: { background: '#005c4b', color: '#53bdeb', borderRadius: 8, padding: '6px 10px', maxWidth: 320, width: '100%', textAlign: 'center', fontSize: 13, boxSizing: 'border-box' },
};
